define('widgets/inputs/date/viewmodel',[
    'knockout',
    'underscore',
    'moment',
    'widgets/inputs/AbstractInputWidget'
], function (ko, _, moment, AbstractInputWidget) {

    /**
     * Usage:
     *
     *      <div data-bind="inputs.date: settings"></div>
     *
     * Settings:
     *      {core/FormFields.dateField} field
     *      {Observable String} label
     *      {Boolean} autoFocus (Default: false)
     */
    function DateInputWidget() {

        AbstractInputWidget.call(this);

        this.placeholder = ko.observable('');
    }

    DateInputWidget.prototype = Object.create(AbstractInputWidget.prototype);

    DateInputWidget.prototype.interceptTabs = function(self, event) {

        if (event.keyCode === 9 && !self.field.isGood()) {
            self.field.value(self.field.value() + ' ');
            event.preventDefault();
            return false;
        }

        return true;
    };

    DateInputWidget.prototype.trimAfterCursor = function(self, event) {

        if (event.target.selectionStart < self.field.value().length) {
            self.field.value( self.field.value().substring(0, event.target.selectionStart) );
            event.preventDefault();
            return false;
        }

        return true;
    };

    DateInputWidget.prototype.activate = function(settings) {

        var self = this,
            format,
            separator;

        AbstractInputWidget.prototype.activate.call(this, settings);

        self.label = settings.label;

        settings.field.locale.subscribeAndExec(function(locale) {

            format = moment.localeData(locale).longDateFormat('L').replace(/(\W)/g, ' $1 ');
            separator = / \W /.exec(format)[0];

            self.placeholder(format);
            self.field.dateFormat(format);
        });

        self.subscriptions.push(self.field.value.subscribe(_.withPrevious('', function(value, previous) {

            var newValue = value || '',
                regexRemoveFirstSeparator = /^(\d)\d\D{0,2}$/,
                regexAddFirstSeparator = /^(\d{2})$/;

            if (format.split(separator)[0].length === 4) {
                regexRemoveFirstSeparator = /^(\d{3})\d\D{0,2}$/;
                regexAddFirstSeparator = /^(\d{4})$/;
            }


            // Detect deletes by checking if current viewValue is a subset of previous
            if (value.length <= previous.length) {

                // If deleting into a separator, remove it and the preceding digit
                newValue = newValue
                    .replace(regexRemoveFirstSeparator, '$1')

                    // Remove second separator
                    .replace(/^(\d+\D+\d)\d\D{0,2}$/, '$1');

            } else {

                newValue = newValue
                    .replace(regexAddFirstSeparator, '$1' + separator)

                    // Add second separator
                    .replace(/^(\d+\D+\d{2})$/, '$1' + separator);
            }

            self.field.value(

                newValue
                    // Must start with digit character
                    .replace(/^\D+/g, '')

                    // Manage separators
                    .replace(/\D+/g, separator)

                    // No separators beyond the third part
                    .replace(/(\w+\W+\w+\W+\w+)\W+/, '$1')

                    // Handle zero prefixes
                    .replace(/(^|\D)(\d)(\D)/, '$10$2$3')
            );

        })));

    };

    return DateInputWidget;

});

